import React, { useEffect, useMemo, useState, useRef } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Grid,
  Box,
  Button,
  TextField,
  InputAdornment,
  Card,
  Typography,MenuItem, Select, CardContent
} from "@mui/material";
import {
  useDeleteCustomerMutation,
  useGetAllInvoiceQuery,
  useGetCompanyQuery,
  useGetCustomerQuery,
  useGetWorkOrderQuery,
  useGetDriverQuery
} from "../../../Api/attoDeskApi";
import {
  ICompanyDetails,
  IInvoice,
} from "../../../Api/Interface/api.interface";
import DeletePopup from "../../../Components/Delete/DeletePopup";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import { useNavigate } from "react-router-dom";
import { useStyles } from "../../../theme/appStyles";
import { useNotifier } from "../../../Core/Notifier";
import { CiSearch } from "react-icons/ci";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import VisibilitySharpIcon from "@mui/icons-material/VisibilitySharp";
import CustomCheckbox from "../../../Components/Checkbox.tsx";
import Pagination from "../../../Components/Pagination";
import { WorkOrderStatus, TransferType, } from "../../../Core/Enum/enum";
import dayjs from "dayjs";
import * as XLSX from "xlsx";
import ReactToPrint from "react-to-print";
import LocalPrintshopSharpIcon from "@mui/icons-material/LocalPrintshopSharp";
import RestartAltIcon from "@mui/icons-material/RestartAlt"; 
import moment from "moment";
import DownloadIcon from '@mui/icons-material/Download';
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import html2pdf from "html2pdf.js";

dayjs.extend(utc);
dayjs.extend(timezone);

// Excel Export Handler


interface Payment {
  id: number;
  work_order_id: number;
  amount: number;
  payment_date: string;
  payment_method: string;
  created_at: string;
  InvoiceNo: string;
  is_deleted: number;
}


const getStatusLabel = (statusCode: number): string => {
  switch (statusCode) {
    case WorkOrderStatus.Paid:
      return "Paid";
    case WorkOrderStatus.Cancel:
      return "Canceled";
    case WorkOrderStatus.Pending:
      return "Pending";
      case WorkOrderStatus.Initiated:
        return "Initiated";
    default:
      return "Unknown Status";
  }
};

const getStatusColor = (statusCode: number): string => {
  switch (statusCode) {
    case WorkOrderStatus.Paid:
      return "#4caf50";
    case WorkOrderStatus.Cancel:
      return "#f44336";
    case WorkOrderStatus.Pending:
      return "#ff9800";
   case WorkOrderStatus.Initiated:
  return "#2196f3"
    default:
      return "#9e9e9e";
  }
};

const Index = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { showErrorMessage, showMessage } = useNotifier();
  const [searchQuery, setSearchQuery] = useState("");
  const [currentSearchQuery, setCurrentSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [selectedCoursing, setSelectedCoursing] = useState<IInvoice | null>(
    null
  );
  const debouncedSearchQuery = useDebounce(searchQuery, 300);
  const [openDialog, setOpenDialog] = useState(false);
  const [openDeleteCategory, setOpenDeleteCategory] = useState(false);
  const [coursingToDelete, setCoursingToDelete] = useState<IInvoice | null>(
    null
  );
  //const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
 const capitalize = (str: string | null | undefined): string => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

  const [drivers, setDrivers] = useState<any[]>([]);
  const { data: driverData } = useGetDriverQuery({ searchText: "", id: "" });
  const [selectedDriver, setSelectedDriver] = useState<string>("");
  const [selectedCompany, setSelectedCompany] = useState<string>("");
  const [selectedCustomer, setSelectedCustomer] = useState<string>("");
  const [dateFilter, setDateFilter] = useState<string>("");
  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");
  const componentRef = useRef<HTMLDivElement>(null);
  const [payments, setPayments] = useState<Payment[]>([]); 
  const API_URL = process.env.REACT_APP_API_URL;
  const paymentRef = useRef<HTMLDivElement>(null);

  const { data, isLoading, isError, refetch } = useGetAllInvoiceQuery({
    searchText: currentSearchQuery,
    id: "",
    quoteWorkOrderCustomerId: "",
    quoteWorkOrderCustomerProjectId: "",
  });
  

  const { data: companyData, isLoading: companyLoading } = useGetCompanyQuery({
    searchText: "",
    id: "",
  });
    const {
        data: customerData,
        isLoading: customerIsLoading,
        isError: cutomerError,
        refetch: cutomerRefetch,
      } = useGetCustomerQuery({
        searchText: "",
        id: "",
      });

   const dateOptions = [
  { label: "Today", value: "today" },
  { label: "Yesterday", value: "yesterday" },
  { label: "This Week", value: "this_week" },
  { label: "Last Week", value: "last_week" },
  { label: "This Month", value: "this_month" },
  { label: "Last Month", value: "last_month" },
  { label: "Custom", value: "custom" }
];

   useEffect(() => {
      if (driverData && Array.isArray(driverData.data)) {
        const filteredDrivers = driverData.data.filter((driver: any) => driver.driverUserRole === 'driver');
        setDrivers(filteredDrivers);
      }
    }, [driverData]);

    


    // useEffect(() => {
    //   if (dateFilter !== "custom") {
    //     let start = "";
    //      let end = "";
    //     // let end = dayjs().format("YYYY-MM-DD");
  
    //     switch (dateFilter) {
    //       case "today":
    //         start = end;
    //         break;
    //       case "yesterday":
    //         start = dayjs().subtract(1, "day").format("YYYY-MM-DD");
    //         end = start;
    //         break;
    //       case "this_week":
    //         start = dayjs().startOf("week").format("YYYY-MM-DD");
    //         break;
    //       case "last_week":
    //         start = dayjs().subtract(1, "week").startOf("week").format("YYYY-MM-DD");
    //         end = dayjs().subtract(1, "week").endOf("week").format("YYYY-MM-DD");
    //         break;
    //       case "this_month":
    //         start = dayjs().startOf("month").format("YYYY-MM-DD");
    //         break;
    //       case "last_month":
    //         start = dayjs().subtract(1, "month").startOf("month").format("YYYY-MM-DD");
    //         end = dayjs().subtract(1, "month").endOf("month").format("YYYY-MM-DD");
    //         break;
    //       default:
    //         break;
    //     }
  
    //     setStartDate(start);
    //     setEndDate(end);
    //   }
    // }, [dateFilter]);

    useEffect(() => {
  fetch(`${API_URL}/payments`)
    .then((res) => res.json())
    .then((data) => {
        const activePayments = data.filter((payment: Payment) => payment.is_deleted === 0);
      setPayments(activePayments);
    })
    .catch((err) => console.error('Error fetching payments:', err));
}, []);



    useEffect(() => {
  if (dateFilter !== "custom") {
    let start = "";
    let end = "";
    const now = dayjs().tz("America/Toronto");
    //const now = dayjs().tz("Etc/GMT+12");

    switch (dateFilter) {
      case "today":
        start = end = now.format("YYYY-MM-DD");
        break;
      case "yesterday":
        start = end = now.subtract(1, "day").format("YYYY-MM-DD");
        break;
      case "this_week":
        start = now.startOf("week").format("YYYY-MM-DD");
        end = now.endOf("week").format("YYYY-MM-DD"); //  Include full week
        break;
      case "last_week":
        start = now.subtract(1, "week").startOf("week").format("YYYY-MM-DD");
        end = now.subtract(1, "week").endOf("week").format("YYYY-MM-DD");
        break;
      case "this_month":
        start = now.startOf("month").format("YYYY-MM-DD");
        end = now.endOf("month").format("YYYY-MM-DD"); //  Ensure full month is covered
        break;
      case "last_month":
        start = now.subtract(1, "month").startOf("month").format("YYYY-MM-DD");
        end = now.subtract(1, "month").endOf("month").format("YYYY-MM-DD");
        break;
      default:
        break;
    }

    setStartDate(start);
    setEndDate(end);
  }
}, [dateFilter]);

 
    
  
    // Handle driver selection change
    const handleDriverChange = (event: any) => {
      const selectedDriver = event.target.value;
      setSelectedDriver(selectedDriver); // Update state with the selected driver
    
    };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  useEffect(() => {
    if (debouncedSearchQuery.length >= 4 || debouncedSearchQuery === "") {
      setCurrentSearchQuery(debouncedSearchQuery);
      refetch();
    }
  }, [debouncedSearchQuery]);

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleOpenDialog = (coursing: IInvoice) => {
    setSelectedCoursing(coursing);
    setOpenDialog(true);
   
  };

  const handleCloseDialog = () => {
    setSelectedCoursing(null);
    setOpenDialog(false);
  };

  const handleOpenDeletePopup = (coursing: IInvoice) => {
    setCoursingToDelete(coursing);
    setOpenDeleteCategory(true);
  };

  const handleCloseDeletePopup = () => {
    setCoursingToDelete(null);
    setOpenDeleteCategory(false);
  };

  const [deleteCategory] = useDeleteCustomerMutation();
  const handleDelete = async (id: string) => {
    try {
      const response = await deleteCategory(id).unwrap();
      if (response.status) {
        showMessage("Deleted successfully");
        setOpenDeleteCategory(false);
      } else {
        showErrorMessage("Failed to delete the customer");
      }
    } catch (error) {
      showErrorMessage("Failed to delete the customer");
    }
  };

  if (isLoading)
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );

const handleExportToExcel = () => {
  if (!filteredCoursings.length) return;

  const exportData = filteredCoursings.map((row, index) => {
    const balance = Math.max(
      0,
      parseFloat(row.quoteWorkOrderSaleGrandTotal || "0") -
        parseFloat(String(row.amount_paid) || "0")
    );

    // Drivers
    const drivers =
      Array.isArray(row?.drivers) && row.drivers.length
        ? row.drivers
            .map((driver) => {
              const assignedDrivers = row?.assign_driver?.assign_to
                ? JSON.parse(row.assign_driver.assign_to)
                : [];

              const assigned = assignedDrivers.find(
                (assign: any) => assign.driverId === driver.id
              );

              const priceText = assigned ? ` - $${assigned.price}` : "";

              return `${capitalize(driver.driverFirstName)} ${capitalize(
                driver.driverLastName
              )}${priceText}`;
            })
            .join(", ")
        : "Not Assigned";

    // Transfer Type
    const transferType =
      row?.quoteWorkOrderSale?.length
        ? row.quoteWorkOrderSale
            .map((sale: any) => {
              const label = sale?.transferType
                ? (Object.keys(TransferType) as (keyof typeof TransferType)[])
                    .find(
                      (key) =>
                        TransferType[key] === String(sale.transferType)
                    )
                : "";
              return label || "N/A";
            })
            .join(" | ")
        : "N/A";

    // Transfer Info (From → To)
    const transferInfo =
      row?.quoteWorkOrderSale?.length
        ? row.quoteWorkOrderSale
            .map((sale: any) =>
              sale?.transferTypeFrom && sale?.transferTypeTo
                ? `${sale.transferTypeFrom} → ${sale.transferTypeTo}`
                : "No Transfer Info"
            )
            .join(" | ")
        : "No Transfer Info";

    // Departure (Date only as per your UI)
    // const departure =
    //   row?.quoteWorkOrderSale?.length
    //     ? row.quoteWorkOrderSale
    //         .map((sale: any) =>
    //           sale?.departureDateTime
    //             ? dayjs(sale.departureDateTime).isValid()
    //               ? dayjs(sale.departureDateTime).format("DD-MMM-YY hh:mm A")
    //               : sale.departureDateTime
    //             : "N/A"
    //         )
    //         .join(" | ")
    //     : "N/A";

         const departure =
      row?.quoteWorkOrderSale?.length
        ? row.quoteWorkOrderSale
            .map((sale: any, i: number) =>
              sale?.pickups?.[0]?.dateTime 
                ? dayjs(sale.pickups[0].dateTime).isValid()
                  ? dayjs(sale.pickups[0].dateTime).format("DD-MMM-YY hh:mm A")
                  : sale.pickups[0].dateTime
                : "N/A"
            )
            .join(" | ")
        : "N/A";


      
       
    // Destination (Return time)
    // const destination =
    //   row?.quoteWorkOrderSale?.length
    //     ? row.quoteWorkOrderSale
    //         .map((sale: any) =>
    //           sale?.returnDateTime && dayjs(sale.returnDateTime).isValid()
    //             ? dayjs(sale.returnDateTime).format("DD-MMM-YY hh:mm A")
    //             : "N/A"
    //         )
    //         .join(" | ")
    //     : "N/A";

    return {
      "#": index + 1,
      "Invoice Number": row.InvoiceNo,
      "Status": getStatusLabel(row.quoteWorkOrderStatus),

      // Optional (you commented in UI but keeping here)
      // "Amount": `$${parseFloat(
      //   row.quoteWorkOrderSaleGrandTotal || "0"
      // ).toFixed(2)}`,
      // "Paid Amt": `$${row.amount_paid || "0"}`,
      // "Balance": `$${balance.toFixed(2)}`,

      "Driver(s)": drivers,
      "Transfer Type": transferType,
      "Transfer Info": transferInfo,
      "Departure": departure,
      // "Destination": destination,

      "Issue From":
        row.company?.companyName || row.project?.projectName || "",

      "Issue For": `${
        row.project?.projectName ||
        row.customer?.customerCompanyName ||
        ""
      } (${capitalize(row.customer?.customerFirstName || "")} ${capitalize(
        row.customer?.customerLastName || ""
      )})`,
    };
  });

  const worksheet = XLSX.utils.json_to_sheet(exportData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Invoices");
  XLSX.writeFile(workbook, "tjbus_invoices.xlsx");
};

const handleExportPaymentsToExcel = () => {
  if (!filteredPayments.length) return;

  const exportData = filteredPayments.map((row) => ({
    Date: moment(row.payment_date).format("DD-MMM-YY"),
    "Invoice Number": row.InvoiceNo,
    Amount: `$${parseFloat(String(row.amount) || "0").toFixed(2)}`,
    Method: row.payment_method,
  }));

  // Add a Total row at the end
  const totalAmount = filteredPayments.reduce(
    (sum, row) => sum + parseFloat(String(row.amount) || "0"),
    0
  );

  exportData.push({
    Date: "",
    "Invoice Number": "Total",
    Amount: `$${totalAmount.toFixed(2)}`,
    Method: "",
  });

  const worksheet = XLSX.utils.json_to_sheet(exportData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Payments");
  XLSX.writeFile(workbook, "tjbus_payments.xlsx");
};


  const coursings: IInvoice[] = Array.isArray(data?.data)
    ? (data?.data as IInvoice[])
    : [];

   const isWithinDateRange = (createdAt: string | undefined) => {
  if (!dateFilter || !createdAt) return true;

  const saleDate = new Date(createdAt).toLocaleDateString("en-CA");
  const startDateString = new Date(startDate).toLocaleDateString("en-CA");
  const endDateString = new Date(endDate).toLocaleDateString("en-CA");

  return saleDate >= startDateString && saleDate <= endDateString;
};
 

   const filteredCoursings = coursings.filter((row) => {
  const matchesDriver =
    !selectedDriver ||
    (Array.isArray(row?.drivers) &&
      row.drivers.some((driver) => driver.id === selectedDriver));

  const matchesDate =
    !dateFilter ||
    isWithinDateRange(row.created_at)
    // (Array.isArray(row?.quoteWorkOrderSale) &&
    //   row.quoteWorkOrderSale.some((sale: any) =>
    //     isWithinDateRange(sale.departureDateTime)
    //   ));

  const matchesIssue =
    !selectedCompany ||
    (Array.isArray(row.company)
      ? row.company.some((issue) => issue.id === selectedCompany)
      : row.company?.id === Number(selectedCompany));

        const matchesCustomer =
        !selectedCustomer || (Array.isArray(row.customer) 
        ? row.customer.some((issue) => issue.id === selectedCustomer) // If it's an array, check within
        : row.customer?.id === Number(selectedCustomer));

  return matchesDriver && matchesDate && matchesIssue && matchesCustomer;
});



const filteredPayments = payments.filter((row) => {
  const matchedInvoice = coursings.find(
    (item) => item.work_order_id === row.work_order_id
  );

  if (!matchedInvoice) return false;

  const matchesDriver =
    !selectedDriver ||
    (Array.isArray(matchedInvoice?.drivers) &&
      matchedInvoice.drivers.some((driver) => driver.id === selectedDriver));

  const matchesIssue =
    !selectedCompany ||
    (Array.isArray(matchedInvoice.company)
      ? matchedInvoice.company.some((issue) => issue.id === selectedCompany)
      : matchedInvoice.company?.id === Number(selectedCompany));

  
  const matchesDate = isWithinDateRange(row.payment_date);

  return  matchesDate && matchesDriver && matchesIssue;
});





   const totalInvoices = filteredCoursings.length;

// Total payments sum
const totalPayments = filteredPayments.reduce((sum, invoice) => {
  return sum + Number(invoice.amount || 0); // assuming `settledAmount` holds payment
}, 0);

const totalCash = filteredPayments
  .filter(payment => payment.payment_method?.toLowerCase() === 'cash')
  .reduce((sum, payment) => sum + Number(payment.amount || 0), 0);

const totalCredit = filteredPayments
  .filter(payment => payment.payment_method?.toLowerCase() === 'credit')
  .reduce((sum, payment) => sum + Number(payment.amount || 0), 0);

const totalDebit = filteredPayments
  .filter(payment => payment.payment_method?.toLowerCase() === 'debit')
  .reduce((sum, payment) => sum + Number(payment.amount || 0), 0);


const totalClients = new Set(
  filteredCoursings.map(inv => inv.quoteWorkOrderCustomerId)
).size;


const exportToExcel = () => {
  // Define the filename
  const fileName = "Report.xlsx";

  // Convert the filtered data into a worksheet
  const worksheet = XLSX.utils.json_to_sheet(filteredCoursings);

  // Create a new workbook and append the worksheet
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Coursings");

  // Write and trigger download
  XLSX.writeFile(workbook, fileName);
};

const handleDownloadPDF = () => {
  const element = componentRef.current;

  const opt = {
    margin: 0.5,
    filename: "tjbus_invoices.pdf",
    image: { type: "jpeg", quality: 0.98 },
    html2canvas: {
      scale: 2,
      useCORS: true,

      // ✅ THIS LINE DOES THE MAGIC
      ignoreElements: (el: Element) => el.classList.contains("no-pdf"),
    },
    jsPDF: {
      unit: "in",
      format: "a4",
      orientation: "landscape",
    },
  };

  html2pdf().set(opt).from(element).save();
};
    

  const handleSearch = () => {
    setCurrentSearchQuery(searchQuery);
  };

  const resetFields = () => {
    setSearchQuery("");
    setCurrentSearchQuery("");
    refetch();
  };

  const handleAddProductClick = () => {
    navigate("/quote/create");
  };

  


  return (
   <><div>
   <Grid container spacing={1} sx={{ marginTop: 1 }}>



 
  {/* <Grid item xs={12} mb={2}>
  <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap">
    <Box display="flex" gap={1} flexWrap="wrap">
      {dateOptions.map((option) => (
        <Button
          key={option.value}
          variant={dateFilter === option.value ? "contained" : "outlined"}
          onClick={() => setDateFilter(option.value)}
          size="small"
          sx={{ fontSize: "13px", padding: "6px 12px" }}
        >
          {option.label}
        </Button>
      ))}
    </Box>
    <Button
      variant="outlined"
      onClick={() => setDateFilter("")}
      size="small"
      startIcon={<RestartAltIcon />}
      sx={{ fontSize: "13px", padding: "6px 12px" }}
    >
      Reset
    </Button>
  </Box>
</Grid> */}



     <Grid item xs={12}>
       <Card className={classes.card}>
         <Box mb={2} padding={2}>


           <Grid container spacing={2}>
             {/* Select Driver */}
             <Grid item lg={2} md={2} sm={6} xs={12}>
               <Typography variant="subtitle1" sx={{ marginBottom: 1 }}>
                 Select Driver
               </Typography>
               <Select
                 className={classes.textField}
                 value={selectedDriver}
                 onChange={handleDriverChange}
                 displayEmpty
                 
                 sx={{
                  height: "37px",
                  fontSize: "14px",
                  padding: "4px",
                  minWidth: "120px"
                }}
               >
                 <MenuItem value="">All Drivers</MenuItem>
                 {drivers.map((driver: any) => (
                   <MenuItem key={driver.id} value={driver.id}>
                     {`${capitalize(driver.driverFirstName)} ${capitalize(driver.driverLastName)}`}
                   </MenuItem>
                 ))}
               </Select>
             </Grid>


             <Grid item lg={2} md={2} sm={6} xs={12}>
  <Typography variant="subtitle1" sx={{ marginBottom: 1 }}>
    Issue From
  </Typography>
  <Select
    className={classes.textField}
    value={selectedCompany || ""}
    onChange={(event) => setSelectedCompany(event.target.value)}
    displayEmpty
    sx={{
      height: "37px",
      fontSize: "14px",
      padding: "4px",
      minWidth: "120px"
    }}
  >
    <MenuItem value="">All Companies</MenuItem>
    {companyData && Array.isArray(companyData.data) ? (
      companyData.data.map((company: any) => (
        <MenuItem key={company.id} value={company.id}>
          {`${capitalize(company.companyName)}`}
        </MenuItem>
      ))
    ) : (
      <MenuItem disabled>No data available</MenuItem>
    )}
  </Select>
</Grid>


 <Grid item lg={2} md={2} sm={6} xs={12}>
  <Typography variant="subtitle1" sx={{ marginBottom: 1 }}>
    Issue For
  </Typography>
  <Select
    className={classes.textField}
    value={selectedCustomer || ""}
    onChange={(event) => setSelectedCustomer(event.target.value)}
    displayEmpty
    sx={{
      height: "37px",
      fontSize: "14px",
      padding: "4px",
      minWidth: "120px"
    }}
  >
    <MenuItem value="">All Customers</MenuItem>
    {customerData && Array.isArray(customerData.data) ? (
      customerData.data.map((customer: any) => (
        <MenuItem key={customer.id} value={customer.id}>
         {`${capitalize(customer.customerFirstName || '')} ${capitalize(customer.customerLastName || '')}`}

        </MenuItem>
      ))
    ) : (
      <MenuItem disabled>No data available</MenuItem>
    )}
  </Select>
</Grid>


    <Grid item lg={2} md={2} sm={6} xs={12}>
               <Typography variant="subtitle1" sx={{ marginBottom: 1 }}>
                 Select Date
               </Typography>
               <Select
                 className={classes.textField}
                 value={dateFilter}
                 onChange={(e) => setDateFilter(e.target.value)}
                 displayEmpty
                
                 sx={{
                  height: "37px",
                  fontSize: "14px",
                  padding: "4px",
                  minWidth: "120px"
                }}
               >
                 <MenuItem value="">Select date filter</MenuItem>
                 <MenuItem value="today">Today</MenuItem>
                 <MenuItem value="yesterday">Yesterday</MenuItem>
                 <MenuItem value="this_week">This Week</MenuItem>
                 <MenuItem value="last_week">Last Week</MenuItem>
                 <MenuItem value="this_month">This Month</MenuItem>
                 <MenuItem value="last_month">Last Month</MenuItem>
                 <MenuItem value="custom">Custom</MenuItem>
               </Select>
             </Grid>
 
             {/* Custom Date Fields (Shown Only If "Custom" Is Selected) */}
             {dateFilter === "custom" && (
               <>
                 <Grid item lg={2} md={2} sm={6} xs={12}>
                   <Typography variant="subtitle1" sx={{ marginBottom: 1 }}>
                     Start Date
                   </Typography>
                   <TextField
                   variant="outlined"
                     type="date"
                     size="small"
                    className={classes.textField}
                     value={startDate}
                     onChange={(e) => setStartDate(e.target.value)}
                     InputLabelProps={{ shrink: true }}
                     
                   />
                 </Grid>
                 <Grid item lg={2} md={2} sm={6} xs={12}>
                   <Typography variant="subtitle1" sx={{ marginBottom: 1 }}>
                     End Date
                   </Typography>
                   <TextField
                     type="date"
                     size="small"
                    className={classes.textField}
                     value={endDate}
                     onChange={(e) => setEndDate(e.target.value)}
                     InputLabelProps={{ shrink: true }}
              
                   />
                 </Grid>
               </>
             )}

 
             {/* Select Date */}
             {/* <Grid item lg={2} md={2} sm={6} xs={12}>
               <Typography variant="subtitle1" sx={{ marginBottom: 1 }}>
                 Select Date
               </Typography>
               <Select
                 className={classes.textField}
                 value={dateFilter}
                 onChange={(e) => setDateFilter(e.target.value)}
                 displayEmpty
                
                 sx={{
                  height: "37px",
                  fontSize: "14px",
                  padding: "4px",
                  minWidth: "120px"
                }}
               >
                 <MenuItem value="">Select date filter</MenuItem>
                 <MenuItem value="today">Today</MenuItem>
                 <MenuItem value="yesterday">Yesterday</MenuItem>
                 <MenuItem value="this_week">This Week</MenuItem>
                 <MenuItem value="last_week">Last Week</MenuItem>
                 <MenuItem value="this_month">This Month</MenuItem>
                 <MenuItem value="last_month">Last Month</MenuItem>
                 <MenuItem value="custom">Custom</MenuItem>
               </Select>
             </Grid> */}
 
             {/* Custom Date Fields (Shown Only If "Custom" Is Selected) */}
           
           </Grid>
         </Box>
       </Card>
     </Grid>
   </Grid>
 </div>


{/* <Grid container spacing={2} justifyContent="space-between" sx={{ marginTop: 1 }}>
  {[ // array of your 5 cards
    { title: 'Total Invoice', value: totalInvoices, prefix: '', suffix: '' },
    { title: 'Total Payments', value: totalPayments.toFixed(2), prefix: '$', suffix: '' },
    { title: 'Cash', value: totalCash.toFixed(2), prefix: '$', suffix: '' },
    { title: 'Credit', value: totalCredit.toFixed(2), prefix: '$', suffix: '' },
    { title: 'Debit', value: totalDebit.toFixed(2), prefix: '$', suffix: '' },
    { title: 'Total Clients', value: totalClients, prefix: '', suffix: '' }
  ].map((item, index) => (
    <Grid item xs={12} sm={6} md={2} key={index}>
      <Card elevation={3}>
        <CardContent>
          <Grid container direction="column" alignItems="center">
            <Typography variant="h5" mt={2}>{item.title}</Typography>
            <Typography
              variant="h3"
              sx={{ marginTop: 2, fontWeight: "bold", color: "#4CAF50" }}
            >
              {item.prefix}{item.value}{item.suffix}
            </Typography>
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  ))}
</Grid> */}








 
 <div ref={componentRef} className="print-landscape">
    <Grid container spacing={1}  sx={{ marginTop: 1 }}>
    <Grid item xs={12} sm={12} md={12}>
    <Card className={classes.card}>
        <Grid
          container
          justifyContent={"space-between"}
          spacing={5}
          sx={{ borderBottom: 2, padding: 2 }}
          className={classes.titleGrid}
        >
          <Grid item lg={4} md={4} sm={4} xs={4} pt={2} alignContent={"center"}>
            <Typography className={classes.cardTitle}>Invoices</Typography>
          </Grid>
          <Grid
            item
            lg={8}
            md={8}
            sm={8}
            xs={8}
            sx={{ display: "flex", justifyContent: "flex-end" }}
           
          >
            <Grid
              container
              spacing={1}
              justifyContent="flex-end"
              sx={{ display: "flex" }}
            >
 

              <Grid item className="no-pdf" sx={{ '@media print': {
                      display: 'none',
                    } }}>



                <TextField
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <CiSearch className={classes.searchWidgetIcon} />
                      </InputAdornment>
                    ),
                    classes: {
                      root: classes.formControlList,
                    },
                  }}
                  fullWidth
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="Invoice Number .."
                  sx={{ width: "100%" }}
                  size="small" />
              </Grid>



              {filteredCoursings.length > 0 && (
                <>
  <Grid item className="no-pdf" sx={{ '@media print': {
    display: 'none',
  } }}>
    
        <Button
          variant="contained"
          startIcon={<DownloadIcon  />}
          className={classes.addButton}
            onClick={handleDownloadPDF}
        >
          PDF
        </Button>
      
     
  </Grid>

  <Grid item className="no-pdf" sx={{ '@media print': {
    display: 'none',
  } }}>
        <Button
          variant="contained"
          startIcon={<DownloadIcon />} // You can use any icon you like
          className={classes.addButton}
          onClick={handleExportToExcel}
        >
          Excel
        </Button>
      </Grid>



      </>
)}
            </Grid>
          </Grid>
        </Grid>

        <Grid >
          <TableContainer>
            <Table className={classes.table} sx={{
              width: "100%",
              marginBottom: "1.5rem",
              verticalAlign: "top",
              "& > :not(caption) > * > *": {
                padding: "8px", // Ensure custom padding is applied
              },
              // '@media print': {
              //   width: '100%',
              //   whiteSpace: 'normal', // Allows text wrapping
              // },
            }}>
              <TableHead className={classes.tableHeaderRow}>
                <TableRow>
                  {/* <TableCell className={classes.tablheader}>
                    <CustomCheckbox name="checkbox" />
                  </TableCell> */}
                  <TableCell className={classes.tablheader}>
                    <strong>#</strong>
                  </TableCell>
                  <TableCell className={classes.tablheader}>
                    <strong>Invoice Number</strong>
                  </TableCell>
                  <TableCell className={classes.tablheader}>
                    <strong>Status</strong>
                  </TableCell>
                  {/* <TableCell className={classes.tablheader}>
                    <strong>Amount</strong>
                  </TableCell> */}
                  {/* <TableCell className={classes.tablheader}>
                    <strong>Paid Amt</strong>
                  </TableCell> */}
                  {/* <TableCell className={classes.tablheader}>
                    <strong>Balance</strong>
                  </TableCell> */}
                  <TableCell className={classes.tablheader}>
                    <strong>Driver(s)</strong>
                  </TableCell>
                  <TableCell  className={classes.tablCell}>
                    <strong>Transfer Type</strong></TableCell>
                  <TableCell className={classes.tablheader}>
                    <strong>Transfer Info</strong>
                  </TableCell>
                     <TableCell className={classes.tablheader}>
                    <strong>Departure</strong>
                  </TableCell>
                    {/* <TableCell className={classes.tablheader}>
                    <strong>Destination</strong>
                  </TableCell> */}
                  {/* <TableCell className={classes.tablheader}>
      <strong>D.Price</strong>
    </TableCell> */}
                  <TableCell className={classes.tablheader}>
                    <strong>Issue From</strong>
                  </TableCell>
                  <TableCell className={classes.tablheader}>
                    <strong>Issue For</strong>
                  </TableCell>

                  {/* <TableCell className={classes.tablheader}>
      <strong>Status</strong>
    </TableCell> */}
                  <TableCell
                    className={`${classes.tablheader} no-pdf`} 
                    sx={{ textAlign: "right" ,'@media print': {
                      display: 'none',
                    } }}
                   
                  >
                    <strong>Action</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {isError || filteredCoursings.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={20} align="center">
                      {isError ? "Error fetching data" : "No data available"}
                    </TableCell>
                  </TableRow>
                ) : (
                  filteredCoursings
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row: IInvoice, index) => {
                      const statusLabel = getStatusLabel(
                        row.quoteWorkOrderStatus
                      );
                      const statusColor = getStatusColor(
                        row.quoteWorkOrderStatus
                      );
                      const balance = Math.max(0, parseFloat(row.quoteWorkOrderSaleGrandTotal || "0") - parseFloat(String(row.amount_paid || "0")));



                      return (
                        <TableRow key={row.id} className={classes.tableRowHover}>
                          {/* <TableCell className={classes.tablCell}>
                            <CustomCheckbox name="checkbox" />
                          </TableCell> */}

                          <TableCell scope="row" className={classes.tablCell}>
                            {page * rowsPerPage + index + 1}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            className={classes.tablCell}
                            style={{ whiteSpace: "nowrap" 

                            }}
                            
                          >
                            {row.InvoiceNo}
                          </TableCell>

                          <TableCell scope="row" className={classes.tablCell}>
                            <Button
                              className={classes.statusButtonList}
                              style={{
                                color: statusColor,
                                backgroundColor: row.quoteWorkOrderStatus === WorkOrderStatus.Paid
                                  ? "#e1f8d5"
                                  : row.quoteWorkOrderStatus === WorkOrderStatus.Cancel
                                    ? "#f8d7da"
                                    : row.quoteWorkOrderStatus === WorkOrderStatus.Pending
                                      ? "lightyellow"
                                      : row.quoteWorkOrderStatus === WorkOrderStatus.Initiated
                                        ? "#e2fafa"
                                        : "#ffffff", // Fallback for other statuses
                                border: "solid 1px",
                                borderColor: statusColor,
                                borderRadius: "8px",
                              }}
                            >
                              {statusLabel}
                            </Button>
                          </TableCell>
                        

                          <TableCell component="th" scope="row" className={classes.tablCell}>
  {Array.isArray(row?.drivers) && row.drivers.length
    ? row.drivers
        .map((driver: { id: number; driverFirstName: string; driverLastName: string }) => {
          // Parse assign_to if it's a valid JSON string
          const assignedDrivers = row?.assign_driver?.assign_to ? JSON.parse(row.assign_driver.assign_to) : [];

          // Find the matching driver assignment by driverId
          const assignedDriver = assignedDrivers.find((assign: { driverId: number }) => assign.driverId === driver.id);

          // Get the price if assigned, otherwise default to "Not Assigned"
          const priceText = assignedDriver ? `- $${assignedDriver.price}` : '';

          // Return formatted string with driver name and price
          return `${capitalize(driver.driverFirstName)} ${capitalize(driver.driverLastName)} ${priceText}`;
        })
        .join(', ')
    : 'Not Assigned'}
</TableCell>
<TableCell component="th" scope="row" className={classes.tablCell}>
  {row?.quoteWorkOrderSale?.length ? (
    row.quoteWorkOrderSale.map((sale: any, i: number) => {
      const transferLabel = sale?.transferType
        ? (Object.keys(TransferType) as (keyof typeof TransferType)[])
            .find((key) => TransferType[key] === String(sale.transferType))
        : "";

      return (
        <div key={i} style={{ marginBottom: "6px" }}>
          {transferLabel || "N/A"}
        </div>
      );
    })
  ) : (
    "N/A"
  )}
</TableCell>


                          <TableCell component="th" scope="row" className={classes.tablCell}>
  {(row?.quoteWorkOrderSale) && row.quoteWorkOrderSale.length
    ? row.quoteWorkOrderSale
        .map((sale: any) => 
          sale?.transferTypeFrom && sale?.transferTypeTo
            ? `${sale.transferTypeFrom} to ${sale.transferTypeTo}`
            : 'No Transfer Info'
        )
        .join(', ')
    : 'No Transfer Info'}
</TableCell>

{/* <TableCell component="th" scope="row" className={classes.tablCell}>
  {row?.quoteWorkOrderSale?.length ? (
    row.quoteWorkOrderSale.map((sale: any, i: number) => (
      <div key={i}>
        {sale?.departureAddress && sale?.departureDateTime ? (
          <>
           
             <Typography variant="body2" >
              {dayjs(sale.departureDateTime).isValid()
                ? dayjs(sale.departureDateTime).format("DD-MMM-YY hh:mm A")
                : sale.departureDateTime}
            </Typography>
          </>
        ) : (
          "N/A"
        )}
      </div>
    ))
  ) : (
    "N/A"
  )}
</TableCell>
                    <TableCell component="th" scope="row" className={classes.tablCell}>
  {row?.quoteWorkOrderSale?.length ? (
    row.quoteWorkOrderSale.map((sale: any, i: number) => (
      <div key={i}>
        {sale?.destinationAddress ? (
          <>
           

            {sale?.returnDateTime && dayjs(sale.returnDateTime).isValid() && (
            

               <Typography variant="body2">
                {dayjs(sale.returnDateTime).format("DD-MMM-YY hh:mm A")}
              </Typography>
            )}
          </>
        ) : (
          "N/A"
        )}
      </div>
    ))
  ) : (
    "N/A"
  )}
</TableCell> */}


{/* Departure/Pickup Column */}
<TableCell component="th" scope="row" className={classes.tablCell}>
  {row?.quoteWorkOrderSale?.length ? (
    row.quoteWorkOrderSale.map((sale: any, i: number) => (
      <div key={i}>
        {/* Try new pickup structure first */}
        {sale?.pickups?.[0]?.dateTime ? (
          <Typography variant="body2">
            {dayjs(sale.pickups[0].dateTime).isValid()
              ? dayjs(sale.pickups[0].dateTime).format("DD-MMM-YY hh:mm A")
              : sale.pickups[0].dateTime}
          </Typography>
        ) : sale?.departureDateTime ? (
          /* Fallback to old departureDateTime */
          <Typography variant="body2">
            {dayjs(sale.departureDateTime).isValid()
              ? dayjs(sale.departureDateTime).format("DD-MMM-YY hh:mm A")
              : sale.departureDateTime}
          </Typography>
        ) : (
          "N/A"
        )}
        
        {/* Optional: Show location */}
        {/* {sale?.pickups?.[0]?.city && (
          <Typography variant="caption" color="textSecondary">
            {sale.pickups[0].city}
          </Typography>
        )} */}
      </div>
    ))
  ) : (
    "N/A"
  )}
</TableCell>


{/* <TableCell component="th" scope="row" className={classes.tablCell}>
  {row?.quoteWorkOrderSale?.length ? (
    row.quoteWorkOrderSale.map((sale: any, i: number) => (
      <div key={i}>
      
        {sale?.returnPickups?.length && sale.returnPickups[sale.returnPickups.length - 1]?.dateTime ? (
          <>
            <Typography variant="body2">
              {dayjs(sale.returnPickups[sale.returnPickups.length - 1].dateTime).isValid()
                ? dayjs(sale.returnPickups[sale.returnPickups.length - 1].dateTime).format("DD-MMM-YY hh:mm A")
                : sale.returnPickups[sale.returnPickups.length - 1].dateTime}
            </Typography>
            
           
          </>
        ) : sale?.returnDateTime ? (
        
          <Typography variant="body2">
            {dayjs(sale.returnDateTime).isValid()
              ? dayjs(sale.returnDateTime).format("DD-MMM-YY hh:mm A")
              : sale.returnDateTime}
          </Typography>
        ) : (
          "N/A"
        )}
      </div>
    ))
  ) : (
    "N/A"
  )}
</TableCell> */}

                          <TableCell scope="row" className={classes.tablCell}>
                            {row.company.companyName || row.project.projectName || ""}

                          </TableCell>
                          <TableCell scope="row" className={classes.tablCell}>
                            <Grid container>
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                {row.project?.projectName || row.customer?.customerCompanyName || ""}
                              </Grid>
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                {`${row.customer?.customerFirstName?.charAt(0).toUpperCase() + row.customer?.customerFirstName?.slice(1).toLowerCase() || ""} 
${row.customer?.customerLastName?.charAt(0).toUpperCase() + row.customer?.customerLastName?.slice(1).toLowerCase() || ""}`}
                              </Grid>
                            </Grid>
                          </TableCell>

                         
                          <TableCell scope="row" className={classes.tablCell}>
                            <Grid
                              container
                              spacing={1}
                              sx={{ display: "flex", justifyContent: "flex-end" }}
                            >


                              <Grid item className="no-pdf" sx={{ '@media print': {
                      display: 'none',
                    } }}>
                                <Button
                                  variant="contained"
                                  className={classes.viewButtonList}
                                  onClick={() => navigate(`/work-order/history/${row.work_order_id}`)}
                                >
                                  <VisibilitySharpIcon
                                    className={classes.viewListIcon} />
                                </Button>
                              </Grid>


                            </Grid>
                          </TableCell>
                        </TableRow>
                      );
                    })
                )}
              </TableBody>
            </Table>
            <Grid className="no-pdf" sx={{ '@media print': {
                    display: 'none',
                  } }}
              spacing={5}
              p={"18px"}
              py={4}
              justifyContent={"end"}
              container
              textAlign={"center"}
              alignContent={"center"}
              alignItems={"center"}
            >
              <Grid
                sx={{
                  textAlign: "end",
                  justifyContent: "flex-end",
                  alignItems: "flex-end",
                }}
              >
                <Pagination 
                  count={filteredCoursings.length}
                  page={page}
                  rowsPerPage={rowsPerPage}
                  onPageChange={handleChangePage} />
              </Grid>
            </Grid>
          </TableContainer>

          {coursingToDelete && (
            <DeletePopup
              open={openDeleteCategory}
              handleCloseDelete={handleCloseDeletePopup}
              onConfirm={async () => {
                await handleDelete(coursingToDelete.id.toString());
              } }
              title="Delete Quote"
              content={`Are you sure you want to delete "${coursingToDelete.quoteWorkOrderNo}"?`} />
          )}
        </Grid>
      </Card>
      </Grid>
      </Grid>
      </div>


 {/* <Grid container spacing={1}  sx={{ marginTop: 1 }}>
        <Grid item xs={12} sm={12} md={12}>
          <div ref={paymentRef} >
    <Card className={classes.card}>
        <Grid
          container
          justifyContent={"space-between"}
          spacing={5}
          sx={{ borderBottom: 2, padding: 2 }}
          className={classes.titleGrid}
        >
          <Grid item lg={4} md={4} sm={4} xs={4} pt={2} alignContent={"center"}>
            <Typography className={classes.cardTitle}>Payments</Typography>
          </Grid>
          <Grid
            item
            lg={8}
            md={8}
            sm={8}
            xs={8}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Grid
              container
              spacing={1}
              justifyContent="flex-end"
              sx={{ display: "flex" }}
            >
            
{filteredPayments.length > 0 && (
    <>
  <Grid item sx={{ '@media print': {
    display: 'none',
  } }}>
    <ReactToPrint
      trigger={() => (
        <Button
          variant="contained"
          startIcon={<LocalPrintshopSharpIcon />}
          className={classes.addButton}
        >
          Print
        </Button>
      )}
      content={() => paymentRef.current}
      documentTitle={"tjbus_payments"}
    />
  </Grid>

   <Grid item sx={{ '@media print': { display: 'none' } }}>
      <Button
        variant="contained"
        startIcon={<DownloadIcon />}
        className={classes.addButton}
        onClick={handleExportPaymentsToExcel}
      >
        Excel
      </Button>
    </Grid>
     </>
)}

            </Grid>
          </Grid>
        </Grid>

        <Grid>
          <TableContainer>
            <Table className={classes.table}>
                       <TableHead className={classes.tableHeaderRow}>
                         <TableRow>
                          <TableCell className={classes.tablheader}>
                             <strong>Date</strong>
                           </TableCell>
                           <TableCell className={classes.tablheader}>
                             <strong>Invoice Number</strong>
                           </TableCell>
                           <TableCell className={classes.tablheader}>
                             <strong>Amount</strong>
                           </TableCell>
                           <TableCell className={classes.tablheader}>
                             <strong>Method</strong>
                           </TableCell>
                         
                        
                           
                         </TableRow>
                       </TableHead>
                       <TableBody>
                         {isError || payments.length === 0 ? (
                           <TableRow>
                             <TableCell colSpan={20} align="center">
                               {isError ? "Error fetching data" : "No data available"}
                             </TableCell>
                           </TableRow>
                         ) : (
                           filteredPayments
                          
                             .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                             .map((row: Payment, index) => {
                              
                               return (
                                 <TableRow key={row.id} className={classes.tableRowHover}>
                                 
                                  <TableCell component="th" scope="row" className={classes.tablCell}>
                                   {moment(row.payment_date).format("DD-MMM-YY")}
                                    </TableCell>

                                   <TableCell
                                     component="th"
                                     scope="row"
                                     className={classes.tablCell}
                                     sx={{ whiteSpace: "nowrap" }} 
                                   >
                                     {row.InvoiceNo}
                                   </TableCell>
                                
                                  
                                   <TableCell
                                     component="th"
                                     scope="row"
                                     className={classes.tablCell}
                                   >
                                       {"$"}
                                             {row.amount}
                                    
                                   </TableCell>
                                   <TableCell  component="th" scope="row"  className={classes.tablCell}>
                                       {row.payment_method}
                                   </TableCell>
                                  
                                  
                               
                                 </TableRow>
                               );
                             })
                         )}

                         <TableRow>

   <TableCell className={classes.tablCell} />

  <TableCell className={classes.tablCell} style={{ fontWeight: 'bold' }}>
    Total
  </TableCell>
 <TableCell className={classes.tablCell} style={{ fontWeight: 'bold' }}>
  ${filteredPayments.reduce((sum, row) => sum + parseFloat(String(row.amount || "0")), 0).toFixed(2)}
</TableCell>




  <TableCell className={classes.tablCell} colSpan={3} />
</TableRow>
                       </TableBody>
                     </Table>
            <Grid sx={{ '@media print': {
                      display: 'none',
                    } }}
              spacing={5}
              p={"18px"}
              py={4}
              justifyContent={"end"}
              container
              textAlign={"center"}
              alignContent={"center"}
              alignItems={"center"}
            >
              <Grid
                sx={{
                  textAlign: "end",
                  justifyContent: "flex-end",
                  alignItems: "flex-end",
                }}
              >
                <Pagination
                  count={filteredPayments.length}
                  page={page}
                  rowsPerPage={rowsPerPage}
                  onPageChange={handleChangePage} />
              </Grid>
            </Grid>
          </TableContainer>

        </Grid>
      </Card>
      </div>
      </Grid>
      </Grid>   */}









      </>
  );
};

export default Index;
